package game.ui;

import cerastes.tools.UIEditor;
import data.Parts.PartDef;
import cerastes.ui.AdvancedText;
import h2d.Object;
import cerastes.SoundManager;
import cerastes.Utils;
import cerastes.fmt.CUIResource.CUIEntity;
import cerastes.c2d.Vec2;
import h2d.Interactive;
import cerastes.ui.Button;
import cerastes.fmt.CUIResource.CUIObject;
import cerastes.ui.UIEntity;
#if tools
import cerastes.tools.ImguiTool.ImGuiToolManager;
import imgui.ImGuiMacro.wref;
import imgui.ImGui;
import cerastes.tools.ImguiTools.IG;
#end

@:structInit class UIPartSocketDef extends CUIObject
{
}

@:build(cerastes.macros.Callbacks.CallbackGenerator.build())
@:build(cerastes.macros.UIEntityBuilder.build( UIPartSocketDef ))
class UIPartSocket extends UIEntity
{
	#if tools
	@:keep public static function getInspector( def: UIPartSocketDef ) {
	}
	#end

	@:obj public var intRoot: Interactive;
	@:obj public var bmpSprite: h2d.Bitmap;

	public var uipart: UIPart;

	public var desiredPart: PartDef;

	@:callbackStatic
	public static function onPartDropped( );

	public override function initialize( root: h2d.Object )
	{
		//removeChildren();
		//root = hxd.Res.ui.part_slot.toObject(this);

		cerastes.macros.UIPopulator.populateObjects();
		super.initialize(root);
	

	}

	// @todo someday: This whole setup is super gross and bad but I don't 
	// have time to fix it so here's the 12th band-aid 
	public function setPart( p: UIPart )
	{
		uipart = p;
		p.setSocket(this);
		addChild(p);
	}

	public function setPartAccepted( p: PartDef )
	{
		desiredPart = p;

		var entry = null;

		switch( p.type )
		{
			case 0: // Capacitor
				entry = Utils.getAtlasEntry("atlases/ui.catlas|capacitor1socket");
			case 1: // Sound chip
				entry = Utils.getAtlasEntry("atlases/ui.catlas|longchipsocket");
				
			case 2: // Processor
				entry = Utils.getAtlasEntry("atlases/ui.catlas|squarechipsocket");
			default:
		}
		bmpSprite.tile = entry.tile;
		intRoot.width = bmpSprite.width;
		intRoot.height = bmpSprite.height;
	}

	override function tick( d: Float )
	{
		if( intRoot == null )
			return;


		var bounds = getBounds();


		var dp: UIPart = Std.downcast(UIEntity.draggingEntity, UIPart);
		if( dp == null )
		{
			// Flow keeps repositioning us and I have no idea but fuck you you're 0 now
			if( uipart != null  )
				uipart.x = 0;

			if( uipart != null && uipart.parent != this )
			{
				uipart = null;
			}
			return;
		}

		if( dp.part.type != desiredPart.type )
			return;

		if( uipart == null )
		{

			var p: Vec2 = {x: bounds.xMin + intRoot.width / 2, y: bounds.yMin + intRoot.height / 2 };
			dp.setDragValid( queryDragPoint( p, game.ui.UITypes.DragKey.Part ) );
		}


	}

	override function onDrop( other: UIEntity )
	{
		addChild( other );
		var p: UIPart = cast other;
		p.setSocket( this );
		uipart = p;
		p.x = 0;
		p.y = 0;
	}

	public function onPartDetached()
	{
		uipart = null;
	}

	public function reset()
	{
		uipart.remove();
	}

}